module.exports = __webpack_public_path__ + "static/media/completed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/completed.svg
// module id = 528
// module chunks = 0